/*
 * /support (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import {
	Container,
	Divider,
	Page,
	PageHeader,
	Skeleton,
} from "@psychology/react-ui"
import { ArrowLeft } from "lucide-react"
import { SupportDocumentGenerate } from "../../features/support/components/support-document-generate"
import { SupportDocumentList } from "../../features/support/components/support-document-list"
import { trpc } from "../../trpc"
import { authPageLoader } from "../../utils/auth.utils"

export const Route = createFileRoute("/support/")({
	component: SupportPage,
	loader: authPageLoader,
})

function SupportPage() {
	const { user } = Route.useLoaderData()

	const { data: supportDocuments, isLoading } =
		trpc.supportDocument.getAllByFilter.useQuery({
			sort: { column: "createdAt", direction: "desc" },
			where: { userId: user.id },
		})

	return (
		<Page centerVertical={false}>
			<Container width={"xl"} padding={"lg"} gap={"sm"}>
				<PageHeader
					title={"Support Documents"}
					left={{
						href: "/dashboard",
						label: "Dashboard",
						Icon: <ArrowLeft size={20} />,
					}}
				/>
				<Divider />
				<SupportDocumentGenerate />
				<Divider />
				{isLoading ? (
					<div className={"space-y-3"}>
						{[1, 2, 3].map((i) => (
							<Skeleton key={i} className={"h-[80px] w-full rounded-lg"} />
						))}
					</div>
				) : (
					<SupportDocumentList supportDocuments={supportDocuments || []} />
				)}
			</Container>
		</Page>
	)
}
